import React, { useEffect, useState } from 'react'
// import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material'
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Table, IconButton, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tooltip, Card, Grid, Button } from '@mui/material'
import { useTranslation } from 'react-i18next';
import Label from 'src/components/Label';
import useLayoutContext from 'src/hooks/useAuthLayout';
import useAuth from 'src/hooks/useAuth';
import confirmSweetAlert from 'src/utils/confirm';
import axios from 'axios';
import DateInput from './DateTimeInput';
// import useAuth from 'src/hooks/useAuth';
import EditIcon from '@mui/icons-material/Edit';

const applyPagination = (medicosLista, page, limit) => {
    return medicosLista.slice(page * limit, page * limit + limit);
};

// export default function ListaAgenda({ lista, getDatos }) {
export default function ListaAgenda({ lista, getDatos, setItem }) {
    const { t } = useTranslation();
    const { dias } = useLayoutContext()
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const { user } = useAuth()
    const { modalOpen } = useLayoutContext()
    const [listaFiltrada, setListaFiltrada] = useState(lista);
    useEffect(() => {
        setListaFiltrada(lista);
    }, [lista]);
    // const { user } = useAuth()
    const handlePageChange = (_event, newPage) => {
        setPage(newPage);
    };

    const handleLimitChange = (event) => {
        setLimit(parseInt(event.target.value));
    };

    const estadoAgenda = async (obj) => {

        let rpta = await confirmSweetAlert(obj.estado_agenda === 1 ? 'Desactivar agenda' : 'Activar agenda',
            obj.estado_agenda === 1 ? 'Esta seguro que desea desactivar la agenda' : 'Esta seguro que desea activar la agenda',
            'info',
            true
        )

        if (rpta) {
            let comentario = obj.estado_agenda === 1 ? 'La agenda fue desactivada por ' : 'La agenda fue activada por '
            let nombres = user.datos.ape_paterno + ' ' + user.datos.ape_materno + ' ' + user.datos.nombres
            await axios.post(`https://apis-anterior.vesaliohce.com.pe/estadoAgenda`, {
                idAgenda: obj.id,
                comentario: comentario + nombres,
                estado: obj.estado_agenda === 1 ? 0 : 1
            })
            getDatos(modalOpen.item.personalId.asignacion_id)
        }


    }

    const [text, setText] = useState({
        fecha: {
            value: '',
            error: false,
            errorText: ''
        }
    });
    const onchangedDate = (e) => {
        setText(x => (
            {
                ...x,
                [e.target.name]: {
                    value: e.target.value,
                    error: e.error,
                    errorText: e.errorText,
                }
            }
        ));
    };
    const onBlurDate = (e) => {
        setText(x => (
            {
                ...x,
                [e.name]: {
                    ...x[e.name],
                    error: e.error,
                    errorText: e.errorText,
                }
            }
        ));
    }

    const paginatedmedicosLista = applyPagination(listaFiltrada, page, limit);

    return (
        <>

            <Grid
                sx={{
                    px: { xs: 0, md: 4 },
                    pb: 2
                }}
                container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                spacing={4}
            >
                <Grid item xs={5}>
                    <Card sx={{ p: 1, display: "flex", gap: 1 }}>
                        <DateInput
                            value={text.fecha.value}
                            onChange={onchangedDate}
                            onBlur={onBlurDate}
                            size='small'
                            label={"Fecha"}
                            name={"fecha"}
                            error={text.fecha.error}
                            helperText={
                                text.fecha.errorText
                            }
                        />

                        <Button
                            fullWidth
                            size='small'
                            variant="contained"
                            sx={{ width: "200px" }}
                            onClick={() => {
                                if (text.fecha.value) {
                                    const fechaFiltro = text.fecha.value;
                                    const nuevaLista = lista.filter(x => x.inicio_vigencia.split('T')[0] === fechaFiltro);
                                    setListaFiltrada(nuevaLista);
                                    setPage(0);
                                } else {
                                    setListaFiltrada(lista);
                                }
                            }}
                        >
                            Aplicar filtro
                        </Button>

                    </Card>
                </Grid>

            </Grid>



            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('')}</TableCell>
                            <TableCell>{t('Día')}</TableCell>
                            <TableCell>{t('Fecha Inicio')}</TableCell>
                            <TableCell>{t('Fecha Fin')}</TableCell>
                            <TableCell>{t('Hora')}</TableCell>
                            <TableCell>{t('Duracion turno')}</TableCell>
                            <TableCell>{t('Estado')}</TableCell>
                            <TableCell>{t('Consultorio')}</TableCell>
                            <TableCell>{t('Creado por')}</TableCell>
                            <TableCell>{t('Fecha crea')}</TableCell>
                            <TableCell align="center">{t('Acciones')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedmedicosLista.sort(function (a, b) {
                            if (a.dia > b.dia) {
                                return 1;
                            }
                            if (a.dia < b.dia) {
                                return -1;
                            }
                            return 0;
                        }).map((list) => {
                            return (
                                <TableRow hover key={list.id} >
                                    <TableCell>
                                        <IconButton 
                                        onClick={()=>setItem(list)}>
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            {dias.find(x => x.id === parseInt(list.dia)).value}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary"
                                        >
                                            <b>{list.inicio_vigencia.split('T')[0]}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary"
                                        >
                                            <b>{list.fin_vigencia.split('T')[0]}</b>
                                        </Typography>

                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary"
                                        >
                                            <b>{list.hora_inicio}</b>
                                        </Typography>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary"
                                        >
                                            <b>{list.hora_fin}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            {list.duracion_turno}
                                        </Typography>
                                    </TableCell>
                                    {/* <TableCell>
                                        <Typography noWrap variant="h5">
                                            {list.comentario}
                                        </Typography>
                                    </TableCell> */}
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            <Label color={parseInt(list.estado_agenda) === 1 ? 'success' : 'error'}>{list.estado_agenda === 1 ? 'Activo' : 'Inactivo'}</Label>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            {list.consultorio}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            {list.usuario}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography noWrap variant="h5">
                                            {list.created_at.split("T")[0]}
                                        </Typography>
                                        <Typography noWrap variant="h5">
                                            {list.created_at.split("T")[1].split('Z')[0].split('.')[0]}
                                        </Typography>
                                    </TableCell>
                                    {(user.datos.numero_documento === '07969613' || 
                                    user.datos.numero_documento === '43440517' || user.datos.numero_documento === '44841509'
                                        || user.datos.numero_documento === '44583685' || user.datos.numero_documento === '48138928'
                                        || user.datos.numero_documento === '40466608' || user.datos.numero_documento === '10585943'
                                    ) && <TableCell align="center">
                                            <Typography noWrap>
                                                <Tooltip title={t(list.estado_agenda === 1 ? 'Desactivar agenda' : 'Ativar agenda')} arrow>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => estadoAgenda(list)}

                                                    >
                                                        {
                                                            list.estado_agenda === 1 && <DeleteTwoToneIcon fontSize="small" />
                                                        }

                                                        {
                                                            list.estado_agenda !== 1 && <CheckIcon fontSize="small" />
                                                        }



                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>

                                        </TableCell>}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box p={2}>
                <TablePagination
                    component="div"
                    count={lista.length}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 15]}
                />
            </Box>
        </>
    )
}
